import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const setProviderType = (providerType) => {
  return {
    type: actionTypes.SET_PROVIDER_TYPE,
    providerType: providerType,
  };
};
export const fetchProviderTypeFailed = (error) => {
  return {
    type: actionTypes.FETCH_PROVIDER_TYPE_FAILED,
    payload: error,
  };
};

export const fetchProviderType = () => {
  return (dispatch) => {
    axios
      .get(serverconfigs.fetchProviderTypeUrl)
      .then((response) => {
        console.log(response.data);
        dispatch(setProviderType(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchProviderTypeFailed(error));
      });
  };
};

export const setProviderSpeciality = (providerSpeciality) => {
  return {
    type: actionTypes.SET_PROVIDER_SEPCIALITY,
    providerSpeciality: providerSpeciality,
  };
};
export const fetchProviderSpecialityFailed = (error) => {
  return {
    type: actionTypes.FETCH_PROVIDER_SEPCIALITY_FAILED,
    payload: error,
  };
};

export const fetchProviderSpeciality = (providerType: string) => {
  return (dispatch) => {
    axios
      .get(
        serverconfigs.fetchProviderSpecialityUrl +
          `?providerType=${providerType}`
      )
      .then((response) => {
        console.log(response.data);
        dispatch(setProviderSpeciality(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchProviderSpecialityFailed(error));
      });
  };
};

export const fetchProviderSpecialities = (providerTypeId: number) => {
  return (dispatch) => {
    let url: string = "";
    if (providerTypeId === 0) {
      url = serverconfigs.fetchProviderSpecialitiesUrl;
    } else {
      url =
        serverconfigs.fetchProviderSpecialitiesUrl +
        `?providerTypeId=${providerTypeId}`;
    }
    axios
      .get(url)
      .then((response) => {
        console.log(response.data);
        dispatch(setProviderSpeciality(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchProviderSpecialityFailed(error));
      });
  };
};
